<template>
  <div class="operationLog" ref="timeline">
    <div
      class="noData"
      v-if="!list.length"
      style="text-align: center; margin-top: 120px"
      v-loading="isLoading"
    >
      <img
        src="../../../src/assets/image/common/noData.png"
        alt=""
        style="322px;height:99px;"
      />
      <span>暂无数据···</span>
    </div>

    <el-timeline class="fine-scroll-bar"  v-else>
      <el-timeline-item
        v-for="item in list"
        :key="item.id"
        :timestamp="handleFormatDateAndTime(item.createTime)"
        placement="top"
      >
        <div>
          <div
            v-html="item.operateTypeStr ? item.operateTypeStr : '无数据'"
            style="
              font-weight: 500;
              font-size: 12px;
              color: #16181a;
              font-family: SourceHanSansCN-Medium;
              margin-bottom: 16px;
              color: #16181A;
            "
          ></div>
          <div
            v-if="item.operateContent"
            v-html="item.operateUserName + item.operateContent"
            style="
              margin-bottom: 16px;
              font-size: 12px;
              font-family: SourceHanSansCN-Regular;
              color: #4F5D78;
            "
          ></div>
          <div>
            <div
              v-if="!item.items"
              v-html="item.operateUserName + item.operateTypeStr"
              style="
                margin-bottom: 16px;
                font-size: 12px;
                font-family: SourceHanSansCN-Regular;
                color: #4F5D78;
              "
            ></div>
            <div
              v-else
              v-for="i in item.items"
              :key="i.id"
              style="
                margin-bottom: 16px;
                font-size: 12px;
                font-family: SourceHanSansCN-Regular;
                color: #4F5D78;"
            >
                {{ item.operateUserName }} 将 <span class="logClass">{{i.typeStr }}</span>
                从<span class="logClass"> {{ i.beforeValue ? `【${i.beforeValue}】` : '---' }}</span> 变为
                <span class="logClass">{{ i.afterValue ? `【${i.afterValue}】` : '---' }}</span>
            </div>

           
          </div>
        </div>
      </el-timeline-item>
    </el-timeline>
    <div v-if="list.length" style="text-align: center; margin-top: 26px; margin-bottom:31px" >
      <el-pagination
        background
        layout="prev, pager, next"
        :total="totalNum"
        :page-size="10"
        :currentPage.sync="currentPage"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    list: {
      default: () => [],
      type: Array,
    },
    isLoading:{
      type:Boolean
    },
    totalNum:{
      type: Number
    },
   
  },
  data(){
    return {
      currentPage: 1,
    }
  },
  methods: {
    //日期格式化
    handleFormatDateAndTime(value) {
      if (value) {
        return moment(value).format('YYYY-MM-DD HH:mm:ss')
      }
      return '--'
    },
    // 切换页数
    handleCurrentChange(val){
      this.currentPage=val
      this.$emit('getLogList',this.currentPage)
      const ele = document.querySelector('.custom-concat-list')
      ele.scrollTop =0
    },
  },
}
</script>

<style lang="scss" scoped>
.operationLog {
  // 时间线样式
  ::v-deep .el-timeline {
    // height: calc(100vh - 183px);
    // overflow-y: auto;
    padding-top: 12px;
    padding-left: 92px;
  }
  ::v-deep .el-timeline-item {
    top: 4px;
    left: -8px;
  }
  ::v-deep .el-timeline-item__timestamp.is-top {
    width: 80px;
    position: absolute;
    left: -92px;
    top: -6px;
    color: #4f5d78;
    line-height: 20px;
    text-align: right;
    font-size: 14px;
  }
  ::v-deep .el-timeline-item__content {
    position: relative;
    top: -4px;
    p {
      font-weight: 400;
      font-size: 14px;
      color: #4f5d78;
    }
  }
  ::v-deep .el-timeline-item__node {
    height: 8px;
    width: 8px;
    background: #98a3b7;
  }
  ::v-deep .el-timeline-item__tail {
    height: 100%;
    top: 8px;
    left: 2px;
  }
  ::v-deep .el-timeline-item:last-child {
    .el-timeline-item__tail {
      display: inline !important;
      height: 55% !important;
      top: 8px;
      left: 2px;
    }
  }
  .noData {
    span {
      display: block;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #98a3b7;
      margin-top: 16px;
    }
  }
}
</style>
<style>
.logClass{
  color: #16181a;
}

</style>